import invoiceModule from '../module.js'

invoiceModule.directive('taxrateDropdown', ['httpRequest', 'dictService', (httpRequest, dictService) => ({
    scope: {
        goods: '<',
        invoiceType: '<',
        taxChange: '&',
    },
    template: `
        <div class="dropdown">
          <div class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ng-click="queryTaxRateArr()">
            <span ng-show="showTaxRate()" title="{{goods.taxRateObj.taxText}}" class="et-taxrate-dropdown et-input-nowrap" style="max-width: calc(100% - 14px);">
                {{goods.taxRateObj.taxText}}
            </span>
            <span class="caret" style="float:right;margin-top: 10px;margin-right:4px"></span>
          </div>
          <ul class="dropdown-menu" ng-show="goods.active" style="min-width: 100px;">
            <li ng-repeat="m in goods.taxRateArr" ng-class="{active:m.taxRate==goods.taxRate && goods.privilegeType == m.privilegeType}" style="text-align: left;padding-left: 5px;">
            <a href="javascript:;" ng-click="selectTaxRate(m)" style="padding-left: 5px;">{{m.taxText}}</a> </li>
          </ul>
        </div>
    `,
    replace: true,
    link (scope) {
        dictService.getAndCache(['zero_tax']).then((res) => {
            scope.dictionary = res
        })

        function getGoodsInfoTax () {
            const {
                goods,
                invoiceType,
            } = scope
            const rateReq = {
                taxMergeCode: goods.taxMergeCode,
                invType: invoiceType,
                privilegeType: encodeURIComponent(goods.privilegeType),
            }
            return httpRequest.get_queryGoodsTax(rateReq).then((res) => res.data.value)
        }

        function makeTaxRateObj (goods) {
            if (goods.taxRate == 10.02 && !(scope.goods.isRed && scope.invoiceType == '0')) return
            const { taxRateArr } = goods
            taxRateArr.forEach((taxRateObj) => {
                if (taxRateObj.taxRate === goods.taxRate
                    && taxRateObj.privilegeType === goods.privilegeType) {
                    goods.taxRateObj = taxRateObj
                }
            })
        }
        scope.showTaxRate = function showTaxRate () {
            if (scope.goods.taxRate == 10.02 && !(scope.goods.isRed && scope.invoiceType == '0')) return
            return scope.goods.taxRate || scope.goods.taxRate === 0
        }
        scope.queryTaxRateArr = function queryTaxRateArr () {
            const { goods } = scope
            if (goods.taxRate == 10.02 && !(scope.goods.isRed && scope.invoiceType == '0')) return
            if (goods.copyInvoiceType != undefined && scope.invoiceType != goods.copyInvoiceType) {
                goods.copyInvoiceType = scope.invoiceType
                goods.taxRateLoaded = false
            }
            if (scope.showTaxRate() && !goods.taxRateLoaded) {
                getGoodsInfoTax(goods, scope.invoiceType).then((reteArr) => {
                    goods.taxRateArr = reteArr
                    makeTaxRateObj(goods)
                    goods.taxRateLoaded = true
                    goods.active = true
                })
            } else {
                goods.active = true
            }
        }
        scope.selectTaxRate = function selectTaxRate (taxRateObj) {
            if (taxRateObj.taxRate == 10.02) return
            const { goods } = scope
            goods.$taxRate = taxRateObj.taxRate
            goods.taxRateObj = taxRateObj
            goods.privilegeType = taxRateObj.privilegeType
            goods.isPrivilege = taxRateObj.isPrivilege
            for (let i = 0, l = scope.dictionary.zero_tax.length; i < l; i++) {
                if (scope.dictionary.zero_tax[i].enumName === taxRateObj.privilegeType && goods.$taxRate === 0) {
                    goods.zeroTax = scope.dictionary.zero_tax[i].enumCode
                }
            }
            scope.taxChange && scope.taxChange(goods)
        }
        scope.$watch('goods.taxRateArr', () => {
            makeTaxRateObj(scope.goods)
        })
    },
})])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/taxrateDropdown.js